module.exports = __webpack_public_path__ + "static/media/logo.0d38d904.png";